export function convertDateTime(value?: number | null): string {
  if (!value) {
    return '-';
  }
  return new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(value * 1000);
}
